/* ARK Products — Custom Reviews hydration.
   SSR (snippets/custom-reviews.liquid) renders the first page from product
   metafields; this wires filter / sort / load-more / submit / photo-upload
   via the ARK engage App Proxy.

   Endpoints (proxyBase = window.ARK_REVIEWS.proxyBase, default /apps/ark-engage/reviews):
     GET    {proxyBase}?product=&model=&sort=&limit=&offset=   list (public)
     POST   {proxyBase}                                        create (login required, 401 if guest)
     POST   {proxyBase}/media                                  photo upload (image/* raw body) -> {key,url}
   PUT {proxyBase}/:id (own edit) exists in the contract but no edit UI is wired here. */
(function () {
  'use strict';

  const root = document.querySelector('[data-custom-reviews]');
  if (!root) return;

  const cfg = window.ARK_REVIEWS || {};
  const proxy = root.dataset.proxy || cfg.proxyBase || '/apps/ark-engage/reviews';
  const productId = root.dataset.productId;
  const loggedIn = root.dataset.loggedIn === '1';
  const loginUrl = root.dataset.loginUrl || cfg.loginUrl || '/account/login';
  const PAGE = Number(root.dataset.pageSize) || cfg.pageSize || 10;

  const MAX_PHOTOS = 10;
  const MAX_INLINE_THUMBS = 3;
  const MAX_PHOTO_BYTES = 8 * 1024 * 1024;
  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const MODEL_LABEL = {
    jl: 'JL Wrangler',
    jk: 'JK Wrangler',
    'jt-gladiator': 'JT Gladiator',
    other: 'その他',
  };

  const listEl = root.querySelector('[data-custom-reviews-list]');
  const statusEl = root.querySelector('[data-custom-reviews-status]');

  const state = {
    model: '',
    sort: 'recent',
    photosOnly: false,
    offset: listEl ? listEl.querySelectorAll('[data-custom-review]').length : 0,
  };

  const SVG_NS = 'http://www.w3.org/2000/svg';

  function el(tag, cls, text) {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function svgEl(inner, filled) {
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    if (filled) {
      svg.setAttribute('fill', 'currentColor');
    } else {
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.75');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
    }
    svg.innerHTML = inner; // static markup only — no user data
    return svg;
  }

  // 投稿日は必ず JST で切る。端末の TZ で切ると、日本の顧客が海外から見たときや
  // 端末設定が JST でないときに投稿日が 1 日ずれる。
  const JST_YMD = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Tokyo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  function fmtDate(value) {
    if (value == null || value === '') return '';
    // engage PublicReview.date は ISO 8601 文字列。数値 (Unix 秒) も後方互換で許容。
    const isUnix = typeof value === 'number' || /^\d+$/.test(String(value));
    const d = isUnix ? new Date(Number(value) * 1000) : new Date(value);
    if (isNaN(d.getTime())) return '';
    const p = {};
    JST_YMD.formatToParts(d).forEach((part) => {
      p[part.type] = part.value;
    });
    return p.year + '.' + p.month + '.' + p.day;
  }

  /* engage App Proxy は成功時 { success:true, data:… } の封筒で返す。
     data ペイロードだけ取り出す (旧 flat 応答にも耐えるよう fallback)。 */
  function payloadOf(json) {
    if (json && typeof json === 'object' && json.data != null) return json.data;
    return json;
  }

  function setStatus(msg, kind) {
    if (!statusEl) return;
    if (!msg) {
      statusEl.hidden = true;
      statusEl.textContent = '';
      return;
    }
    statusEl.hidden = false;
    statusEl.textContent = msg;
    statusEl.setAttribute('data-kind', kind || 'ok');
  }

  /* ---------- card builder (mirrors SSR markup) ---------- */
  function stars(rating) {
    const s = el('span', 'custom-rv-stars');
    s.style.setProperty('--custom-rv-fill', (rating / 5) * 100 + '%');
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', rating + ' / 5');
    const bg = el('span', 'custom-rv-stars__bg', '★★★★★');
    const fg = el('span', 'custom-rv-stars__fg', '★★★★★');
    bg.setAttribute('aria-hidden', 'true');
    fg.setAttribute('aria-hidden', 'true');
    s.append(bg, fg);
    return s;
  }

  function gauge(diff) {
    const wrap = el('div', 'custom-review__gauge');
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', '取付難易度 ' + diff + ' / 5');
    wrap.append(el('span', 'custom-review__gauge-label', '取付難易度'));
    const segs = el('div', 'custom-review__segs');
    segs.setAttribute('aria-hidden', 'true');
    for (let i = 1; i <= 5; i++) {
      segs.append(el('span', 'custom-review__seg' + (i === diff ? ' is-active' : ''), String(i)));
    }
    wrap.append(segs);
    const scale = el('div', 'custom-review__gauge-scale');
    scale.setAttribute('aria-hidden', 'true');
    scale.append(el('span', null, 'かんたん'), el('span', null, '専門知識が必要'));
    wrap.append(scale);
    return wrap;
  }

  function media(r) {
    const photos = Array.isArray(r.photos) ? r.photos : [];
    if (!photos.length && !r.video) return null;
    const wrap = el('div', 'custom-review__media');
    photos.forEach((src, i) => {
      const a = el('a', 'custom-review__thumb' + (i >= MAX_INLINE_THUMBS ? ' is-extra' : ''));
      a.href = src;
      a.target = '_blank';
      a.rel = 'noopener';
      if (i >= MAX_INLINE_THUMBS) a.hidden = true;
      const img = el('img');
      img.src = src;
      img.loading = 'lazy';
      img.alt = '';
      img.width = 120;
      img.height = 120;
      a.append(img);
      if (i === 0) a.append(el('span', 'custom-review__thumb-tag', '実車'));
      wrap.append(a);
    });
    if (r.video) {
      const v = el('a', 'custom-review__video');
      v.href = r.video;
      v.target = '_blank';
      v.rel = 'noopener';
      v.setAttribute('aria-label', '動画レビューを開く');
      v.append(svgEl('<polygon points="6 3 20 12 6 21 6 3"/>', true));
      wrap.append(v);
    }
    const extra = photos.length - MAX_INLINE_THUMBS;
    if (extra > 0) {
      const more = el('button', 'custom-review__more', '+' + extra);
      more.type = 'button';
      more.setAttribute('data-custom-review-expand', '');
      wrap.append(more);
    }
    return wrap;
  }

  function detail(r) {
    const wrap = el('div', 'custom-review__detail');
    wrap.setAttribute('data-custom-review-detail', '');
    wrap.hidden = true;
    const dl = el('dl', 'custom-review__specs');
    if (r.model) {
      dl.append(
        el('dt', null, '車種'),
        el('dd', null, MODEL_LABEL[r.model] || String(r.model).toUpperCase())
      );
    }
    if (r.year) {
      dl.append(el('dt', null, '年式'), el('dd', null, String(r.year)));
    }
    if (r.difficulty) {
      dl.append(el('dt', null, '取付難易度'), el('dd', null, r.difficulty + ' / 5'));
    }
    wrap.append(dl);
    return wrap;
  }

  function card(r) {
    const li = el('li', 'custom-review' + (r.verified ? ' is-verified' : ''));
    li.setAttribute('data-custom-review', '');

    const head = el('div', 'custom-review__head');
    head.append(stars(Number(r.rating) || 0));
    if (r.model) {
      const label = MODEL_LABEL[r.model] || String(r.model).toUpperCase();
      head.append(el('span', 'custom-review__fit', (r.year ? r.year + ' ' : '') + label));
    }
    const meta = el('span', 'custom-review__meta');
    if (r.verified) {
      const badge = el('span', 'custom-review__verified');
      badge.append(svgEl('<circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>'));
      badge.append(document.createTextNode('購入確認済み'));
      meta.append(badge);
    }
    meta.append(el('span', 'custom-review__author', r.author || ''));
    meta.append(el('time', 'custom-review__date', fmtDate(r.date)));
    head.append(meta);
    li.append(head);

    if (r.difficulty) li.append(gauge(Number(r.difficulty)));
    if (r.title) li.append(el('h3', 'custom-review__title', r.title));

    const body = el('p', 'custom-review__body is-clamped', r.body || '');
    body.setAttribute('data-custom-review-body', '');
    li.append(body);

    const m = media(r);
    if (m) li.append(m);

    const disc = el('button', 'custom-review__disclose');
    disc.type = 'button';
    disc.setAttribute('data-custom-review-toggle', '');
    disc.setAttribute('aria-expanded', 'false');
    disc.append(el('span', null, '詳細を見る'));
    disc.append(svgEl('<path d="m6 9 6 6 6-6"/>'));
    li.append(disc);
    li.append(detail(r));
    return li;
  }

  /* ---------- expand / collapse (delegated; SSR + dynamic) ---------- */
  function expandCard(cardEl, open) {
    if (!cardEl) return;
    const toggle = cardEl.querySelector('[data-custom-review-toggle]');
    const detailEl = cardEl.querySelector('[data-custom-review-detail]');
    const body = cardEl.querySelector('[data-custom-review-body]');
    const extras = cardEl.querySelectorAll('.custom-review__thumb.is-extra');
    const moreBtn = cardEl.querySelector('.custom-review__more');
    if (detailEl) detailEl.hidden = !open;
    if (body) body.classList.toggle('is-clamped', !open);
    extras.forEach((x) => {
      x.hidden = !open;
    });
    if (moreBtn) moreBtn.hidden = open;
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      const label = toggle.querySelector('span');
      if (label) label.textContent = open ? '詳細を閉じる' : '詳細を見る';
    }
  }

  if (listEl) {
    listEl.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-custom-review-toggle]');
      if (toggle) {
        const cardEl = toggle.closest('[data-custom-review]');
        expandCard(cardEl, toggle.getAttribute('aria-expanded') !== 'true');
        return;
      }
      const expandBtn = e.target.closest('[data-custom-review-expand]');
      if (expandBtn) {
        expandCard(expandBtn.closest('[data-custom-review]'), true);
      }
    });
  }

  /* ---------- list fetch ---------- */
  async function fetchList(reset) {
    if (!listEl) return;
    if (reset) state.offset = 0;
    root.classList.add('is-loading');
    const sort = state.photosOnly ? 'photos' : state.sort;
    try {
      const params = new URLSearchParams({
        product: productId,
        model: state.model,
        sort: sort,
        limit: String(PAGE),
        offset: String(state.offset),
      });
      const res = await fetch(proxy + '?' + params.toString(), {
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) throw new Error('list ' + res.status);
      const body = payloadOf(await res.json());
      const reviews = (body && body.reviews) || [];
      if (reset) listEl.textContent = '';
      reviews.forEach((r) => listEl.append(card(r)));
      state.offset += reviews.length;
      if (reset && reviews.length === 0) {
        listEl.append(el('li', 'custom-reviews__empty', '条件に一致するレビューはありません。'));
      }
      const moreBtn = root.querySelector('[data-custom-reviews-more]');
      if (moreBtn) moreBtn.hidden = reviews.length < PAGE;
      setStatus('');
    } catch {
      setStatus('レビューの取得に失敗しました。時間をおいて再度お試しください。', 'error');
    } finally {
      root.classList.remove('is-loading');
    }
  }

  /* ---------- controls ---------- */
  const chipWrap = root.querySelector('[data-custom-reviews-models]');
  if (chipWrap) {
    chipWrap.querySelectorAll('.custom-reviews__chip').forEach((chip) => {
      chip.addEventListener('click', () => {
        chipWrap
          .querySelectorAll('.custom-reviews__chip')
          .forEach((c) => c.classList.remove('is-active'));
        chip.classList.add('is-active');
        state.model = chip.dataset.model || '';
        fetchList(true);
      });
    });
  }

  const sortSel = root.querySelector('[data-custom-reviews-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', () => {
      state.sort = sortSel.value;
      fetchList(true);
    });
  }

  const photosToggle = root.querySelector('[data-custom-reviews-photos]');
  if (photosToggle) {
    photosToggle.addEventListener('change', () => {
      state.photosOnly = photosToggle.checked;
      fetchList(true);
    });
  }

  const moreBtn = root.querySelector('[data-custom-reviews-more]');
  if (moreBtn) {
    moreBtn.addEventListener('click', () => fetchList(false));
  }

  function resetControls() {
    state.model = '';
    state.sort = 'recent';
    state.photosOnly = false;
    if (sortSel) sortSel.value = 'recent';
    if (photosToggle) photosToggle.checked = false;
    if (chipWrap) {
      chipWrap
        .querySelectorAll('.custom-reviews__chip')
        .forEach((c) => c.classList.remove('is-active'));
      const all = chipWrap.querySelector('.custom-reviews__chip[data-model=""]');
      if (all) all.classList.add('is-active');
    }
  }

  /* ---------- submit modal ---------- */
  function showError(errEl, msg) {
    if (!errEl) return;
    errEl.hidden = false;
    errEl.textContent = msg;
  }
  function hideError(errEl) {
    if (!errEl) return;
    errEl.hidden = true;
    errEl.textContent = '';
  }

  function renderPreview(input, preview, label, errEl) {
    if (!preview) return;
    preview.querySelectorAll('img').forEach((img) => URL.revokeObjectURL(img.src));
    preview.textContent = '';
    const files = Array.from(input.files || []);
    if (files.length > MAX_PHOTOS) {
      showError(errEl, '写真は最大' + MAX_PHOTOS + '枚までです。');
    } else {
      hideError(errEl);
    }
    files.slice(0, MAX_PHOTOS).forEach((f) => {
      const img = document.createElement('img');
      img.src = URL.createObjectURL(f);
      img.alt = '';
      preview.append(img);
    });
    if (label) {
      label.textContent = files.length
        ? files.length + '枚を選択中'
        : '写真を選択またはドラッグ＆ドロップ';
    }
  }

  async function uploadPhotos(input) {
    const keys = [];
    if (!input || !input.files || !input.files.length) return keys;
    const files = Array.from(input.files);
    // 10枚超は先頭だけ silent upload せず提出をブロックする (枚数を減らすまで送信不可)。
    if (files.length > MAX_PHOTOS) {
      throw new Error(
        '写真は最大' + MAX_PHOTOS + '枚までです。選択を' + MAX_PHOTOS + '枚以下に減らしてください。'
      );
    }
    for (const file of files) {
      if (!/^image\//.test(file.type)) throw new Error('画像ファイルのみアップロードできます。');
      if (file.size > MAX_PHOTO_BYTES) throw new Error('画像は1枚あたり8MB以内にしてください。');
      const res = await fetch(proxy + '/media', {
        method: 'POST',
        headers: { 'Content-Type': file.type },
        body: file,
      });
      if (res.status === 401) {
        window.location.href = loginUrl;
        throw new Error('ログインが必要です。');
      }
      if (!res.ok) throw new Error('写真のアップロードに失敗しました。');
      const uploaded = payloadOf(await res.json());
      keys.push(uploaded.key);
    }
    return keys;
  }

  async function onSubmit(e, form, ratingInput, errEl, close, photoInput) {
    e.preventDefault();
    hideError(errEl);
    const submitBtn = form.querySelector('[data-custom-reviews-submit]');
    submitBtn.disabled = true;
    try {
      if (!ratingInput.value) throw new Error('評価を選んでください。');
      const bodyVal = (form.querySelector('[name="body"]').value || '').trim();
      if (bodyVal.length < 10) throw new Error('本文は10文字以上でご記入ください。');
      const photoKeys = await uploadPhotos(photoInput);
      const fd = new FormData(form);
      const payload = {
        productId: productId,
        rating: Number(fd.get('rating')),
        title: fd.get('title') || undefined,
        body: bodyVal,
        vehicleModel: fd.get('vehicleModel') || undefined,
        vehicleYear: fd.get('vehicleYear') ? Number(fd.get('vehicleYear')) : undefined,
        installDifficulty: fd.get('installDifficulty')
          ? Number(fd.get('installDifficulty'))
          : undefined,
        videoUrl: fd.get('videoUrl') || undefined,
        photoKeys: photoKeys,
      };
      const res = await fetch(proxy, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      if (res.status === 401) {
        window.location.href = loginUrl;
        return;
      }
      if (res.status === 409) throw new Error('この商品には既にレビューを投稿済みです。');
      if (res.status === 422) {
        let details = [];
        try {
          const d = await res.json();
          details = d.details || [];
        } catch {
          details = [];
        }
        throw new Error(
          '入力内容をご確認ください。' + (details.length ? ' (' + details.join(', ') + ')' : '')
        );
      }
      if (!res.ok) throw new Error('送信に失敗しました。時間をおいて再度お試しください。');
      const out = payloadOf(await res.json());
      close();
      const approved = out && out.status === 'approved';
      setStatus(
        approved
          ? 'レビューを公開しました。ありがとうございます。'
          : 'レビューを受け付けました。確認後に公開されます。',
        'ok'
      );
      if (approved) {
        resetControls();
        fetchList(true);
      }
    } catch (err) {
      showError(errEl, err && err.message ? err.message : 'エラーが発生しました。');
    } finally {
      submitBtn.disabled = false;
    }
  }

  function focusablesIn(container) {
    return Array.from(container.querySelectorAll(FOCUSABLE)).filter(
      (elm) => !elm.hasAttribute('hidden') && (elm.offsetWidth > 0 || elm.offsetHeight > 0)
    );
  }

  function openModal(evt) {
    if (!loggedIn) {
      window.location.href = loginUrl;
      return;
    }
    // dialog を閉じたらフォーカスを戻すため、開いた trigger を控える。
    const opener = (evt && evt.currentTarget) || document.activeElement;
    const tpl = root.querySelector('[data-custom-reviews-modal-tpl]');
    if (!tpl) return;
    const node = tpl.content.firstElementChild.cloneNode(true);
    document.body.append(node);

    const form = node.querySelector('[data-custom-reviews-form]');
    const ratingInput = form.querySelector('input[name="rating"]');
    const diffInput = form.querySelector('input[name="installDifficulty"]');
    const errEl = node.querySelector('[data-custom-reviews-error]');

    function onKey(ev) {
      if (ev.key === 'Escape') {
        close();
        return;
      }
      if (ev.key !== 'Tab') return;
      // フォーカスを dialog 内に閉じ込める (先頭↔末尾でループ)。
      const items = focusablesIn(node);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;
      if (ev.shiftKey && (active === first || !node.contains(active))) {
        ev.preventDefault();
        last.focus();
      } else if (!ev.shiftKey && (active === last || !node.contains(active))) {
        ev.preventDefault();
        first.focus();
      }
    }
    function close() {
      node
        .querySelectorAll('[data-custom-reviews-preview] img')
        .forEach((img) => URL.revokeObjectURL(img.src));
      document.removeEventListener('keydown', onKey);
      node.remove();
      if (opener && typeof opener.focus === 'function') opener.focus();
    }
    document.addEventListener('keydown', onKey);
    node.querySelector('[data-custom-reviews-close]').addEventListener('click', close);
    node.addEventListener('click', (evt) => {
      if (evt.target === node) close();
    });

    const rateStars = node.querySelectorAll(
      '[data-custom-reviews-rate] .custom-reviews-rate__star'
    );
    rateStars.forEach((star) => {
      star.addEventListener('click', () => {
        const v = Number(star.dataset.val);
        ratingInput.value = String(v);
        rateStars.forEach((s) => s.classList.toggle('is-on', Number(s.dataset.val) <= v));
      });
    });

    const diffOpts = node.querySelectorAll(
      '[data-custom-reviews-difficulty] .custom-reviews-segpick__opt'
    );
    diffOpts.forEach((opt) => {
      opt.addEventListener('click', () => {
        const v = Number(opt.dataset.val);
        diffInput.value = String(v);
        diffOpts.forEach((o) => o.classList.toggle('is-active', Number(o.dataset.val) === v));
      });
    });

    const bodyInput = node.querySelector('[data-custom-reviews-body-input]');
    const bodyCount = node.querySelector('[data-custom-reviews-body-count]');
    if (bodyInput && bodyCount) {
      bodyInput.addEventListener('input', () => {
        bodyCount.textContent = String(bodyInput.value.length);
      });
    }

    const photoInput = node.querySelector('[data-custom-reviews-photos]');
    const preview = node.querySelector('[data-custom-reviews-preview]');
    const uploadLabel = node.querySelector('[data-custom-reviews-upload-label]');
    if (photoInput) {
      photoInput.addEventListener('change', () =>
        renderPreview(photoInput, preview, uploadLabel, errEl)
      );
    }

    form.addEventListener('submit', (evt) =>
      onSubmit(evt, form, ratingInput, errEl, close, photoInput)
    );

    // open 時に dialog 内の最初のフォーカス可能要素へ移動 (背景 trigger に残さない)。
    const firstFocusable = focusablesIn(node)[0];
    if (firstFocusable) firstFocusable.focus();
  }

  root
    .querySelectorAll('[data-custom-reviews-open]')
    .forEach((b) => b.addEventListener('click', openModal));
})();
